<div class="database-selector-container" [ngClass]="{'has-selection': selectedDatabase}">
  <div class="selector-content">
    <div class="icon-wrapper">
      <mat-icon class="database-icon">storage</mat-icon>
    </div>
    
    <mat-form-field class="database-select sql-generator-select">
      <mat-select 
        [value]="selectedDatabase?.id" 
        (selectionChange)="onDatabaseChange($event.value)"
        placeholder="Select Database" 
        panelClass="database-select-panel"
        disableOptionCentering>
        <mat-select-trigger>
          <div class="selected-database" *ngIf="selectedDatabase">
            <span [matTooltip]="selectedDatabase?.database_name">
              {{ getFormattedDatabaseName(selectedDatabase?.database_name) }}
            </span>
          </div>
          <div class="no-database" *ngIf="!selectedDatabase">
            <span>Select Database</span>
          </div>
        </mat-select-trigger>
        <mat-option disabled class="dropdown-header">
          Database options
        </mat-option>
        <mat-option *ngFor="let db of databases" [value]="db.id" class="database-option">
          <div class="db-option-content">
            <div class="db-info">
              <span class="db-name" [matTooltip]="db.database_name">{{db.database_name}}</span>
              <span class="db-type">{{formatDatabaseType(db.backend)}}</span>
            </div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div class="selector-status">
    <div class="selector-loading" *ngIf="loading">
      <mat-spinner diameter="16"></mat-spinner>
    </div>
    
    <div class="selector-error" *ngIf="error">
      <button mat-icon-button matTooltip="{{error}}" (click)="retry()">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
</div>
